export default __webpack_public_path__ + "static/media/MAP-new-logo.8d556e97.png";